import React from "react";
import {Doughnut} from "react-chartjs-2"


const GaugeChart = ({color, values, width, text,hideArrow}) => {
    let labels = ["a" ,"b", "c"]
    let data = {
        labels: labels,
        datasets: [
          {
            label: "Accuracy Index",
            data: values,
            backgroundColor: [color,"#fff",],

            needleValue: values[0],
            borderWidth: 0,
            circumference: 180,
            rotation: -90
          },
        ],
      };

      const textCenter =  {
        id: "textCenter",
        beforeDatasetsDraw(chart, args, pluginOptions) {
          const {ctx, config, data,  chartArea:{top, bottom, left, right, width, height}, scales:{x, y}} = chart;
          ctx.save()

          const cx = width / 2;
          const cy = chart._metasets[0].data[0].y;

          ctx.font = 'bolder 14px sans-serif'
          ctx.fillText(text, cx, height)
          ctx.textAlign = "center"
        }
      }

      const arrowPointer = {
        id: 'arrowPointer',
        afterDatasetsDraw(chart, args, plugins) {
          const {ctx, config, data,  chartArea:{top, bottom, left, right, width, height}, scales:{x, y}} = chart;
          ctx.save();

          ctx.font = '14px FontAwesome';

          const cx = width / 2;
          const cy = chart._metasets[0].data[0].y;

          // Translate to the desired position

          ctx.translate(cx, cy);

          

         /*  // Calculate the tilt angle based on the chart width
          const tiltAngle = 30; // Tilt angle in degrees (adjust as needed)

          // Calculate the rotation angle based on the chart data
          const dataMin = 0; // Minimum data value
          const dataMax = 100; // Maximum data value
          const dataValue = 50; // Current data value (adjust as needed)
          const normalizedDataValue = (dataValue - dataMin) / (dataMax - dataMin); // Normalize data value to range [0, 1]
          const rotationRange = 180; // Total rotation range in degrees
          const rotationAngle = normalizedDataValue * rotationRange; // Calculate rotation angle

          // Apply tilt angle and rotation angle
          ctx.rotate((-tiltAngle / 2 + rotationAngle) * (Math.PI / 180)); // Convert angles to radians */

          // Draw the text or symbol at the translated and rotated position
          ctx.fillText('\uf062', -7, 7);

          ctx.restore();
        }
      }

      const gaugeNeedle = {
        id: 'gaugeNeedle',
        afterDatasetsDraw(chart, args, options) {
          const {ctx, config, data,  chartArea:{top, bottom, left, right, width, height}, scales:{x, y}} = chart;
  
          ctx.save();
  
          const dataTotal = 100
          const needleValue = data.datasets[0].needleValue;
          const angle = Math.PI + (1 / dataTotal * needleValue * Math.PI)
  
          const cx = width / 2;
          const cy = chart._metasets[0].data[0].y;
          // Needle
          ctx.translate(cx, cy-2);
          ctx.rotate(angle);
          ctx.beginPath();
          
          ctx.moveTo(0, -1.5);
          ctx.lineTo(height - 32, 0);
          ctx.lineTo(0, 1.5);
          ctx.fillStyle = "#444";
          ctx.fill();
  
          // ctx.moveTo(0, 0);
          // ctx.lineTo(height - 35, 0);
          // ctx.lineWidth = 0.8;
          // ctx.stroke();
  
          // Needle dot
          ctx.translate(-cx, -cy);
          ctx.beginPath();
          ctx.arc(cx, cy, 2, 0, 10);
          ctx.fill();
          ctx.restore();
  
          // ctx.font = 'bolder 14px sans-serif'
          // ctx.fillText(text, cx, height)
          // ctx.textAlign = "center"
        }
      }

    return <React.Fragment>
            <div style={{
                width: width ? width : "60px",
                height:"50px"
            }}>
            <Doughnut data={data}
                plugins={ hideArrow === true ? [textCenter] : [gaugeNeedle, textCenter]}
                options={{
                    plugins:{
                        legend:false,
                        tooltip: false
                    },
                    scales: {
                      x: {
                        display:false,
                        min: 0,
                        max: 10
                      }
                    }
                  }}
                />
            </div>

    </React.Fragment>
}

export default GaugeChart
